import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NavBar: React.FC = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <div className="nav-bar px-0 py-lg-0" style={{ height: "80px" }}>
      <nav className="navbar navbar-expand-lg navbar-light d-flex justify-content-lg-end">
        <Link to="/" className="navbar-brand-2">
          <img src="img/logo-small.png" alt="Logo" />
        </Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse">
          <span className="fa fa-bars"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <div className="navbar-nav mx-0 mx-lg-auto bg-white">
            <div className="nav-item dropdown">
              <a href="inner-page-template.html" className="nav-link" data-bs-toggle="dropdown">
                <span className="dropdown-toggle">About</span>
              </a>
              <div className="dropdown-menu">
                <Link
                  to="/what-we-do"
                  className={`dropdown-item ${location.pathname === '/what-we-do' ? 'active' : ''}`}
                  onClick={closeMenu}>
                  What we do
                </Link>

                <Link
                  to="/our-management"
                  className={`dropdown-item ${location.pathname === '/our-management' ? 'active' : ''}`}
                  onClick={closeMenu}>
                  Our management
                </Link>

                <Link
                  to="/partnerships"
                  className={`dropdown-item ${location.pathname === '/partnerships' ? 'active' : ''}`}
                  onClick={closeMenu}>
                  Partnerships
                </Link>


              </div>
            </div>

            <div className="nav-item dropdown">
              <a href="inner-page-template.html" className="nav-link" data-bs-toggle="dropdown">
                <span className="dropdown-toggle">Projects</span>
              </a>
              <div className="dropdown-menu multi-column columns-2">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="multi-column-dropdown">
                      <div className="nav-heading">Water & Wastewater Treatment Systems</div>
                      <div className="nav-sub-heading">Water Treatment Plants</div>

                      <Link
                        to="/raw-water-pre-treatment"
                        className={`drop-down-nav-link ${location.pathname === '/raw-water-pre-treatment' ? 'active' : ''}`}
                        onClick={closeMenu}>
                        Raw Water Pre-treatment
                      </Link>

                      <Link
                        to="/multi-grade-filters-mgf"
                        className={`drop-down-nav-link ${location.pathname === '/multi-grade-filters-mgf' ? 'active' : ''}`}
                        onClick={closeMenu}>
                        Multi-Grade Filters (MGF)
                      </Link>

                      <Link
                        to="/activated-carbon-filters-acf"
                        className={`drop-down-nav-link ${location.pathname === '/activated-carbon-filters-acf' ? 'active' : ''}`}
                        onClick={closeMenu}>
                        Activated Carbon Filters (ACF)
                      </Link>

                      <Link
                        to="/mixed-bed-units-mb"
                        className={`drop-down-nav-link ${location.pathname === '/mixed-bed-units-mb' ? 'active' : ''}`}
                        onClick={closeMenu}>
                        Mixed Bed Units (MB)
                      </Link>

                      <Link
                        to="/ultra-filtration-uf-plants"
                        className={`drop-down-nav-link ${location.pathname === '/ultra-filtration-uf-plants' ? 'active' : ''}`}
                        onClick={closeMenu}>
                        Ultra Filtration (UF) Plants
                      </Link>

                      <Link
                        to="/reverse-osmosis-ro-plants"
                        className={`drop-down-nav-link ${location.pathname === '/reverse-osmosis-ro-plants' ? 'active' : ''}`}
                        onClick={closeMenu}>
                        Reverse Osmosis (RO) Plants
                      </Link>

                      <Link
                        to="/desalination-plants"
                        className={`drop-down-nav-link ${location.pathname === '/desalination-plants' ? 'active' : ''}`}
                        onClick={closeMenu}>
                        Desalination Plants
                      </Link>

                      <Link
                        to="/electrodeionization-edi"
                        className={`drop-down-nav-link ${location.pathname === '/electrodeionization-edi' ? 'active' : ''}`}
                        onClick={closeMenu}>
                        Electrodeionization (EDI)
                      </Link>


                      <div className="nav-sub-heading">Wastewater Treatment Plants</div>
                      <Link
                        to="/effluent-treatment-plants-etps"
                        className={`drop-down-nav-link ${location.pathname === '/effluent-treatment-plants-etps' ? 'active' : ''}`}
                        onClick={closeMenu}>
                        Effluent Treatment Plants (ETPs)
                      </Link>

                      <Link
                        to="/sewage-treatment-plants-stps"
                        className={`drop-down-nav-link ${location.pathname === '/sewage-treatment-plants-stps' ? 'active' : ''}`}
                        onClick={closeMenu}>
                        MBBR/MBR/SBR based Sewage Treatment Plants (STPs)
                      </Link>

                      <Link
                        to="/multistage-ro-seawater-ro-recycling"
                        className={`drop-down-nav-link ${location.pathname === '/multistage-ro-seawater-ro-recycling' ? 'active' : ''}`}
                        onClick={closeMenu}>
                        Multi-stage RO/Seawater RO recycling Systems
                      </Link>

                      <Link
                        to="/multi-effect-evaporator-mee-agitated-thin-film-dryer-atfd"
                        className={`drop-down-nav-link ${location.pathname === '/multi-effect-evaporator-mee-agitated-thin-film-dryer-atfd' ? 'active' : ''}`}
                        onClick={closeMenu}>
                        Multi effect Evaporator (MEE)/ATFD
                      </Link>


                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="multi-column-dropdown">
                      <div className="nav-heading">Chemical & Process Plants</div>
                      <Link
                        to="/designing-of-industrial-process-piping"
                        className={`drop-down-nav-link ${location.pathname === '/designing-of-industrial-process-piping' ? 'active' : ''}`}
                        onClick={closeMenu}>
                        Designing of Industrial Process & Piping
                      </Link>

                      <Link
                        to="/pipeline-laying"
                        className={`drop-down-nav-link ${location.pathname === '/pipeline-laying' ? 'active' : ''}`}
                        onClick={closeMenu}>
                        Pipeline laying
                      </Link>

                      <Link
                        to="/cooling-towers-enc"
                        className={`drop-down-nav-link ${location.pathname === '/cooling-towers-enc' ? 'active' : ''}`}
                        onClick={closeMenu}>
                        Cooling Towers E&C
                      </Link>

                      <Link
                        to="/dairy-plants"
                        className={`drop-down-nav-link ${location.pathname === '/dairy-plants' ? 'active' : ''}`}
                        onClick={closeMenu}>
                        Dairy Plants
                      </Link>

                      <Link
                        to="/chemical-plants-reactor-systems"
                        className={`drop-down-nav-link ${location.pathname === '/chemical-plants-reactor-systems' ? 'active' : ''}`}
                        onClick={closeMenu}>
                        Chemical Plants - Reactor systems
                      </Link>

                      <div className="nav-sub-heading">BOO Projects</div>
                      <Link
                        to="/boo-build-own-operate-projects"
                        className={`drop-down-nav-link ${location.pathname === '/boo-build-own-operate-projects' ? 'active' : ''}`}
                        onClick={closeMenu}>
                        BOO (Build-Own-Operate) Projects
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="nav-item dropdown">
              <a href="inner-page-template.html" className="nav-link" data-bs-toggle="dropdown">
                <span className="dropdown-toggle">Speciality Chemicals</span>
              </a>
              <div className="dropdown-menu">
                <Link
                  to="/products/ro-antiscalants"
                  className={`dropdown-item ${location.pathname === '/products/ro-antiscalants' ? 'active' : ''}`}
                  onClick={closeMenu}>
                  RO Antiscalants
                </Link>

                <Link
                  to="/boiler-water-treatment"
                  className={`dropdown-item ${location.pathname === '/boiler-water-treatment' ? 'active' : ''}`}
                  onClick={closeMenu}>
                  Boiler Water Treatment
                </Link>

                <Link
                  to="/cooling-water-treatment"
                  className={`dropdown-item ${location.pathname === '/cooling-water-treatment' ? 'active' : ''}`}
                  onClick={closeMenu}>
                  Cooling Water Treatment
                </Link>

                <Link
                  to="/products/etp-stp-chemicals"
                  className={`dropdown-item ${location.pathname === '/products/etp-stp-chemicals' ? 'active' : ''}`}
                  onClick={closeMenu}>
                  ETP/STP Chemicals
                </Link>

              </div>
            </div>

            <div className="nav-item dropdown">
              <a href="inner-page-template.html" className="nav-link" data-bs-toggle="dropdown">
                <span className="dropdown-toggle">Operation & Maintenance</span>
              </a>
              <div className="dropdown-menu">
                <Link
                  to="/products/municipal-wtp-stp-cetps"
                  className={`dropdown-item ${location.pathname === '/products/municipal-wtp-stp-cetps' ? 'active' : ''}`}
                  onClick={closeMenu}>
                  Municipal WTP/STP/CETPs
                </Link>

                <Link
                  to="/products/industrial-water-treatment-plants"
                  className={`dropdown-item ${location.pathname === '/products/industrial-water-treatment-plants' ? 'active' : ''}`}
                  onClick={closeMenu}>
                  Industrial Water Treatment Plants
                </Link>

                <Link
                  to="/products/industrial-wastewater-treatment-plants"
                  className={`dropdown-item ${location.pathname === '/products/industrial-wastewater-treatment-plants' ? 'active' : ''}`}
                  onClick={closeMenu}>
                  Industrial Wastewater Treatment Plants
                </Link>

                <Link
                  to="/products/manpower-supply"
                  className={`dropdown-item ${location.pathname === '/products/manpower-supply' ? 'active' : ''}`}
                  onClick={closeMenu}>
                  Manpower Supply
                </Link>

                <Link
                  to="/products/amc-of-water-wastewater-treatment-plants"
                  className={`dropdown-item ${location.pathname === '/products/amc-of-water-wastewater-treatment-plants' ? 'active' : ''}`}
                  onClick={closeMenu}>
                  AMC of water/wastewater Treatment Plants
                </Link>

              </div>
            </div>

            <div className="nav-item dropdown">
              <a href="inner-page-template.html" className="nav-link" data-bs-toggle="dropdown">
                <span className="dropdown-toggle">Revamping & Modernization</span>
              </a>
              <div className="dropdown-menu">
                <Link
                  to="/products/water-treatment-plants-revamping"
                  className={`dropdown-item ${location.pathname === '/products/water-treatment-plants-revamping' ? 'active' : ''}`}
                  onClick={closeMenu}>
                  Water Treatment Plants Revamping
                </Link>

                <Link
                  to="/products/etp-stp-upgradation"
                  className={`dropdown-item ${location.pathname === '/products/etp-stp-upgradation' ? 'active' : ''}`}
                  onClick={closeMenu}>
                  ETP/STP Upgradation
                </Link>
                <Link
                  to="/products/technology-upgradation"
                  className={`dropdown-item ${location.pathname === '/products/technology-upgradation' ? 'active' : ''}`}
                  onClick={closeMenu}>
                  Technology Upgradation
                </Link>
                <Link
                  to="/products/capacity-enhancement"
                  className={`dropdown-item ${location.pathname === '/products/capacity-enhancement' ? 'active' : ''}`}
                  onClick={closeMenu}>Capacity Enhancement</Link>
              </div>
            </div>
            {/* <Link
              to="/case-studies"
              className={`nav-item nav-link ${location.pathname === '/case-studies' ? 'active' : ''}`}
              onClick={closeMenu}>Case Studies</Link> */}
            <Link
              to="/contact"
              className={`nav-item nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              Contact
            </Link>
          </div>
        </div >
      </nav >
    </div >
  );
};

export default NavBar;
